import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Row, Col } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const StyledSVG = styled(SVG)`
  width: 15px;
  height: 15px;
  fill: ${props => props.theme.colors.color2.bg};
`
const StyledSVG2 = styled(StyledSVG)`
  fill: ${props => props.theme.colors.color1.bg};
`

const FilterItemWrapper = styled(Col)`
  cursor: pointer;
  color: ${props => props.theme.colors.color2.bg};
  margin-bottom: 15px;
  font-size: ${font.size.sm};
  line-height: 18px;
  &.activ {
    color: ${props => props.theme.colors.color1.bg};
  }
`

/************* */

const Seat = props => {
  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { seats } = filters
  const seatsList = filtersDatas.seats

  const handleClick = item => {
    const isSelected = !seats ? false : seats.filter(el => el === item.value).length > 0

    let extendedSeatsValues = seats ? [...seats] : []

    if (!isSelected) {
      extendedSeatsValues.push(item.value)
    } else {
      extendedSeatsValues = seats.filter(el => el !== item.value)
    }

    const extendedFiltersValues = {
      ...filters,
      seats: extendedSeatsValues
    }

    onChangeFilter(extendedFiltersValues)
  }

  const renderIcon = id => {
    let icon

    switch (id) {
      case true:
        icon = (
          <StyledSVG2
            svg={svg.checkboxes.checked}
            data-test="stock-vehicles-list-filters-ecology-FilterItemIconChecked"
          />
        )
        break
      case false:
      default:
        icon = (
          <StyledSVG
            svg={svg.checkboxes.unchecked}
            data-test="stock-vehicles-list-filters-ecology-FilterItemIconUnChecked"
          />
        )
        break
    }
    return icon
  }

  const renderItem = item => {
    const { label } = item

    const isSelected = !seats ? false : seats.filter(el => el === item.value).length > 0

    return (
      <FilterItemWrapper
        key={label}
        onClick={() => handleClick(item)}
        className={isSelected ? 'activ' : ''}
        span={12}
        data-test="stock-vehicles-list-filters-seat-FilterItemWrapper"
      >
        <Row type="flex" gutter={10} style={{ alignItems: 'center' }}>
          <Col>{renderIcon(isSelected)}</Col>
          <Col>
            <FormattedMessage
              id={label}
              data-test="stock-vehicles-list-filters-seat-FilterItemLabel"
            />
          </Col>
        </Row>
      </FilterItemWrapper>
    )
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-seat">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-seat-title'
        })}
        data-test="stock-vehicles-list-filters-seat-title"
      />
      <Row type="flex">{seatsList && seatsList.map(item => renderItem(item))}</Row>
    </div>
  )
}

Seat.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Seat)
